import { render, staticRenderFns } from "./NoRfqModal.vue?vue&type=template&id=16cb4122"
import script from "./NoRfqModal.vue?vue&type=script&lang=js"
export * from "./NoRfqModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports